import { motion } from "framer-motion";
import { FadeIn } from "@/components/animated";
import { Button } from "@learn-me/ui";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, Users, Clock } from "lucide-react";

export function FinalCTASection() {
  return (
    <section className="py-24 relative overflow-hidden">
      {/* Premium gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-900 via-primary-800 to-primary-950" />

      {/* Animated mesh gradient overlay */}
      <motion.div
        className="absolute inset-0 opacity-30"
        animate={{
          background: [
            "radial-gradient(circle at 20% 30%, rgba(59, 130, 246, 0.3) 0%, transparent 50%)",
            "radial-gradient(circle at 80% 70%, rgba(59, 130, 246, 0.3) 0%, transparent 50%)",
            "radial-gradient(circle at 20% 30%, rgba(59, 130, 246, 0.3) 0%, transparent 50%)",
          ],
        }}
        transition={{ duration: 10, repeat: Infinity, ease: "linear" }}
      />

      {/* Decorative elements */}
      <div className="absolute top-10 left-10 w-32 h-32 bg-gold-400/10 rounded-full blur-2xl" />
      <div className="absolute bottom-10 right-10 w-48 h-48 bg-primary-400/10 rounded-full blur-3xl" />

      <div className="container relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <FadeIn>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-primary-200 text-sm font-medium mb-8">
              <Sparkles className="h-4 w-4 text-gold-400" />
              Oferta especial por tiempo limitado
            </div>
          </FadeIn>

          <FadeIn delay={0.1}>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Transforma tu carrera
              <span className="block text-gradient-gold mt-2">
                empezando hoy
              </span>
            </h2>
          </FadeIn>

          <FadeIn delay={0.2}>
            <p className="text-xl text-primary-200 mb-8 max-w-2xl mx-auto leading-relaxed">
              Únete a miles de profesionales que ya están aprendiendo las
              habilidades del futuro. Tu primer curso puede cambiarlo todo.
            </p>
          </FadeIn>

          <FadeIn delay={0.3}>
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10">
              <Link to="/register">
                <motion.div
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <Button
                    size="lg"
                    className="w-full sm:w-auto bg-white text-primary-900 hover:bg-primary-50 font-semibold px-8 py-6 text-lg shadow-premium"
                  >
                    Crear cuenta gratis
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </Button>
                </motion.div>
              </Link>
              <Link to="/courses">
                <motion.div
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <Button
                    variant="outline"
                    size="lg"
                    className="w-full sm:w-auto border-white/30 text-white hover:bg-white/10 px-8 py-6 text-lg"
                  >
                    Explorar cursos
                  </Button>
                </motion.div>
              </Link>
            </div>
          </FadeIn>

          <FadeIn delay={0.4}>
            <div className="flex flex-wrap items-center justify-center gap-6 text-primary-300 text-sm">
              <div className="flex items-center gap-2">
                <Users className="h-4 w-4" />
                <span>+10,000 estudiantes</span>
              </div>
              <div className="w-px h-4 bg-primary-700" />
              <div className="flex items-center gap-2">
                <Clock className="h-4 w-4" />
                <span>Acceso inmediato</span>
              </div>
              <div className="w-px h-4 bg-primary-700" />
              <div className="flex items-center gap-2">
                <Sparkles className="h-4 w-4 text-gold-400" />
                <span>Garantía de 30 días</span>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}
